module.exports = __webpack_public_path__ + "img/720.3b97609b.svg";